export const CheckCircleIcon = ({
  strokeColor = "var(--color-btn-primary-active)",
  ...props
}: any) => (
  <svg {...props} width="15" height="16" viewBox="0 0 15 16" fill="none">
    <g id="Icons All">
      <path
        id="Vector"
        d="M7.5 14.5625C9.31217 14.5625 10.9528 13.828 12.1404 12.6404C13.328 11.4528 14.0625 9.81217 14.0625 8C14.0625 6.18783 13.328 4.54721 12.1404 3.35961C10.9528 2.17203 9.31217 1.4375 7.5 1.4375C5.68783 1.4375 4.04721 2.17203 2.85961 3.35961C1.67203 4.54721 0.9375 6.18783 0.9375 8C0.9375 9.81217 1.67203 11.4528 2.85961 12.6404C4.04721 13.828 5.68783 14.5625 7.5 14.5625Z"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        id="Vector_2"
        d="M4.6875 8L6.5625 9.875L10.3125 6.125"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
